/**
 * @file: 选择器
 * @author: xiaolong.huang@dmall.com
 */

import { panelSelectAsync, panelSelectSync } from './message';
import { clear, getAll, has, getSelectedByType, isEmpty } from './store/index';
import { addOne, removeOne, removeGroup, addGroup, clearAllSelect } from './toolkit';
import { downCancel, upCancel } from './cancelSelect';
import { single } from './singleSelect';
import { ctrl } from './ctrlSelect';
import { shift } from './shiftSelect';
import { all } from './selectAll';
import { byRect } from './selectByRect';
import { cabinetColSelect } from './cabinetColSelect';
import {
    startAnimation,
    stopAnimation,
    stopAllSelectedAnimation,
    startAllSelectedAnimation,
    startAllSelectedAnimationAsync
} from './flowBorder';

export default {
    addOne,
    addGroup,
    removeOne,
    removeGroup,
    downCancel,
    upCancel,
    single,
    ctrl,
    shift,
    all,
    byRect,
    cabinetColSelect,
    panelSelectAsync,
    panelSelectSync,
    getAll,
    has,
    stopAllSelectedAnimation,
    startAllSelectedAnimation,
    startAllSelectedAnimationAsync,
    getSelectedByType,
    startAnimation,
    stopAnimation,
    isEmpty,
    clear: clearAllSelect,
    cleanSystem: clear
}
